import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { NavComponent } from './nav/nav.component';
import { AuthHttp } from './auth-http.service';
import { RouterModule, Routes } from '@angular/router';
import { StaticService } from './static.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AngularLoadingBarModule } from 'ng4-loader-bar';
import { TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NavService } from 'app/core/nav/nav.service';

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, '../../assets/i18n', '.json');
}


// BrowserAnimationsModule,
@NgModule({
  declarations: [NavComponent],
  imports: [SharedModule, RouterModule.forChild([]), AngularLoadingBarModule, TranslateModule.forRoot()
],
  exports: [NavComponent],
  providers: [AuthHttp, StaticService, NavService]
})
export class CoreModule {}



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts